import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect, withRouter } from "react-router-dom";

import { Loading } from "components/StatusScreen";
import { rememberRedirect } from "lib/session";

// Login and sign-up. Signed-in students go straight on to where they were
// heading (?path=), or to My classes.
const GuestRoute = ({ component: Component, location, ...rest }) => {
  const user = useSelector((state) => state.users);
  const path = new URLSearchParams(location?.search).get("path");
  if (path) rememberRedirect(path);

  return (
    <Route
      {...rest}
      render={(props) =>
        user === null ? <Loading /> : user ? <Redirect to={path || "/"} /> : <Component {...props} />
      }
    />
  );
};

export default withRouter(GuestRoute);
